import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getPartCategories, resetSvgPartDataLoading } from "../../axios/index";
import Header from "./Header";
import ActionButtons from "./ActionButtons";
import SaveConfigPopup from "./saveConfigPopup";
import LoadContainer from "./LoadContainer";
import "./index.css";

function SVG() {
  const { moduleName } = useParams();
  const dispatch = useDispatch();

  const [saveEvent, setSaveEvent] = React.useState(false);
  const recordUpdateApiStatus = useSelector((state) => state.recordUpdateApi);
  const parts = useSelector((state) => state.svgViewerPartData);
  const svgSource = useSelector((state) => state.svgViewerData);
  const [preview, setPreview] = React.useState(false);
  const [selectedScale, setSelectedScale] = useState(3);
  const [editMode, setEditMode] = useState(false);
  const [connectionArray, setConnectionArray] = useState([]);
  const [cordPairs, setCordPairs] = useState([]);
  const [holeConnectionArray, setHoleConnectionArray] = useState([]);
  const [holeCordPairs, setHoleCordPairs] = useState([]);
  const [currentPartIndex, setCurrentPartIndex] = useState(null);
  const [newXCord, setNewXCord] = useState(null);
  const [newYCord, setNewYCord] = useState(null);
  const [showModel, setShowModel] = useState(true);

  const getScaleIdFromUnit = (unit) => {
    const normalizedUnit = String(unit || "").toLowerCase();

    if (
      normalizedUnit === "1" ||
      normalizedUnit === "in" ||
      normalizedUnit === "inch" ||
      normalizedUnit === "inches"
    ) {
      return 1;
    }

    if (
      normalizedUnit === "2" ||
      normalizedUnit === "mm" ||
      normalizedUnit === "millimeter" ||
      normalizedUnit === "millimeters"
    ) {
      return 2;
    }

    if (
      normalizedUnit === "3" ||
      normalizedUnit === "cm" ||
      normalizedUnit === "centimeter" ||
      normalizedUnit === "centimeters"
    ) {
      return 3;
    }

    return null;
  };

  const closeModel = () => {
    setShowModel(false);
  };

  useEffect(() => {
    if (
      svgSource?.data?.assemblyData?.metaData?.containerMetaData
        ?.productType !== undefined
    ) {
      dispatch(
        getPartCategories({
          configID:
            svgSource?.data?.assemblyData?.metaData?.containerMetaData
              ?.productType,
        })
      );
    }
  }, [dispatch, svgSource]);

  useEffect(() => {
    if (moduleName === "config-viewer") {
      const configScaleId = getScaleIdFromUnit(
        parts?.data?.configData?.metaData?.configUnits
      );

      if (configScaleId !== null) {
        setSelectedScale(configScaleId);
      }
    }

    if (moduleName === "assembly-viewer") {
      const assemblyScaleId = getScaleIdFromUnit(
        svgSource?.data?.assemblyData?.metaData?.containerMetaData?.cadScale
      );

      if (assemblyScaleId !== null) {
        setSelectedScale(assemblyScaleId);
      }
    }
  }, [
    moduleName,
    parts?.data?.configData?.metaData?.configUnits,
    svgSource?.data?.assemblyData?.metaData?.containerMetaData?.cadScale,
  ]);

  const togglePreview = () => {
    setPreview(!preview);
  };

  const handleSaveEvent = (status) => {
    dispatch(resetSvgPartDataLoading({}));
    setSaveEvent(status);
  };

  const saveRecordEvent = () => {};

  const closeModal = () => {
    setSaveEvent(false);
  };

  const renderSavePopup = () => {
    if (!saveEvent) {
      return null;
    }

    let saveType = "new";
    const isNew = parts.data?.configData?.type;

    if (isNew === "new") {
      saveType = "new";
    } else if (isNew === "existing") {
      saveType = "update";
    }

    const modeldata = {
      module: "Configuration",
      title: "Save Configuration Details",
      icon: "now-ui-icons arrows-1_cloud-download-93",
      info: "You are about to save all the changes. Please select from the given below options.",
      urlId: -1,
      saveType,
    };

    return (
      <>
        <div className="modal-backdrop fade show"></div>
        <SaveConfigPopup
          moduleName={moduleName}
          modal={modeldata}
          saveRecordEvent={saveRecordEvent}
          recordUpdateApiStatus={recordUpdateApiStatus}
          urlId={-1}
          closeModal={closeModal}
          selectedScale={selectedScale}
          setSelectedScale={setSelectedScale}
          editMode={editMode}
          connectionArray={connectionArray}
          setConnectionArray={setConnectionArray}
          cordPairs={cordPairs}
          setCordPairs={setCordPairs}
          currentPartIndex={currentPartIndex}
          setCurrentPartIndex={setCurrentPartIndex}
          holeConnectionArray={holeConnectionArray}
          setHoleConnectionArray={setHoleConnectionArray}
          holeCordPairs={holeCordPairs}
          setHoleCordPairs={setHoleCordPairs}
        />
      </>
    );
  };

  return (
    <>
      <div className="row">
        <div className="col-12 header-bar">
          <div className="col-12 content svg" data-module={moduleName}>
            <Header
              moduleName={moduleName}
              preview={preview}
              editMode={editMode}
              setEditMode={setEditMode}
              selectedScale={selectedScale}
              currentPartIndex={currentPartIndex}
              setCurrentPartIndex={setCurrentPartIndex}
              newXCord={newXCord}
              newYCord={newYCord}
              setXpoint={setNewXCord}
              setYpoint={setNewYCord}
              closeModel={closeModel}
            />

            <ActionButtons
              preview={preview}
              moduleName={moduleName}
              handleSaveEvent={handleSaveEvent}
              previewActive={togglePreview}
              selectedScale={selectedScale}
              setSelectedScale={setSelectedScale}
              editMode={editMode}
            />
          </div>
        </div>
      </div>

      {renderSavePopup()}

      {showModel && (
        <LoadContainer
          editMode={editMode}
          setEditMode={setEditMode}
          preview={preview}
          connectionArray={connectionArray}
          setConnectionArray={setConnectionArray}
          cordPairs={cordPairs}
          setCordPairs={setCordPairs}
          currentPartIndex={currentPartIndex}
          setCurrentPartIndex={setCurrentPartIndex}
          holeConnectionArray={holeConnectionArray}
          setHoleConnectionArray={setHoleConnectionArray}
          holeCordPairs={holeCordPairs}
          setHoleCordPairs={setHoleCordPairs}
          setXpoint={setNewXCord}
          setYpoint={setNewYCord}
        />
      )}
    </>
  );
}

export default SVG;